const templatesTabs = [
  // translated in props
  { name: 'templates', label: 'Email templates' },
  { name: 'welcomeTexts', label: 'Assessment welcome texts' },
];

export default templatesTabs;
